import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconType } from 'shared/icons/SvgIcon.tsx';
import { mergeClasses } from 'shared/utils/mergeClasses.ts';

interface MenuItemProps {
  href: string;
  label: string;
  icon: IconType;
  activePattern?: RegExp;
  className?: string;
}

export const MenuItem: FC<MenuItemProps> = ({
  href,
  label,
  icon: Icon,
  className = '',
  activePattern = href,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const matched = pathname.match(activePattern);

  return (
    <li>
      <button
        className={mergeClasses(
          'mx-auto flex w-full items-center space-x-2 rounded-md p-2 text-sm text-white transition-all sm:w-auto xl:w-full',
          matched ? 'bg-primary' : 'hover:bg-primary-600 active:bg-primary-700',
          className,
        )}
        role="link"
        onClick={() => navigate(href)}
      >
        {Icon && <Icon className="h-5 w-5" />}
        <span className="text-inherit sm:hidden xl:block">{label}</span>
      </button>
    </li>
  );
};
